// extracted by mini-css-extract-plugin
export var header = "Section-module--header--cc414";
export var heading = "Section-module--heading--d4a06";
export var section = "Section-module--section--bd10b";